export default "__VITE_ASSET__698ea0e1__"